export interface Language {
    code: string;
    name: string;
    nativeName: string;
    rtl?: boolean;
}

export const languages: Language[] = [
    { code: 'en', name: 'English', nativeName: 'English' },
    { code: 'ar', name: 'Arabic', nativeName: 'العربية', rtl: true },
    { code: 'da', name: 'Danish', nativeName: 'Dansk' },
    { code: 'de', name: 'German', nativeName: 'Deutsch' },
    { code: 'es', name: 'Spanish', nativeName: 'Español' },
    { code: 'fi', name: 'Finnish', nativeName: 'Suomi' },
    { code: 'fr', name: 'French', nativeName: 'Français' },
    { code: 'it', name: 'Italian', nativeName: 'Italiano' },
    { code: 'ja', name: 'Japanese', nativeName: '日本語' },
    { code: 'ko', name: 'Korean', nativeName: '한국어' },
    { code: 'nb', name: 'Norwegian', nativeName: 'Norsk Bokmål' },
    { code: 'nl', name: 'Dutch', nativeName: 'Nederlands' },
    { code: 'pl', name: 'Polish', nativeName: 'Polski' },
    { code: 'pt', name: 'Portuguese', nativeName: 'Português' },
    { code: 'sv', name: 'Swedish', nativeName: 'Svenska' },
    { code: 'zh', name: 'Chinese', nativeName: '简体中文' },
];

/** Set of RTL language codes for O(1) lookup */
const RTL_CODES = new Set(languages.filter(l => l.rtl).map(l => l.code));

/** Get display name for a language code. Falls back to uppercase code. */
export function getLanguageName(code: string): string {
    const lang = languages.find(l => l.code === code);
    return lang?.name || code.toUpperCase();
}

/** Check if a language code is RTL */
export function isRtlLanguage(code: string): boolean {
    return RTL_CODES.has(code);
}

/** Languages with display names for dropdown. */
export const languagesWithDisplayName = languages.map(l => ({
    ...l,
    displayName: l.code === 'en' ? l.name : `${l.name} (${l.nativeName})`,
}));
